import {
  FEEDBACK_COLUMN_ID,
  FEEDBACK_NOTES_COLUMN_ID,
} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/filters/common';
import {type StyledDataGrid} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/StyledDataGrid';

export interface WeaveTraceConfig {
  savedViewDefinition?: string;
  currentStep?: number | null;
}

export type WeaveStyleDataGridColumns = React.ComponentProps<
  typeof StyledDataGrid
>['columns'];

export interface TraceData {
  callId: string;
  entity: string;
  project: string;
}

export const WEAVE_TRACE_PANEL_TYPE = 'Weave Trace';

// Feedback cells own their click targets (reactions, notes editor); clicking
// them should not open the trace drawer, which steals focus (WB-33678).
export const isFeedbackInteractionField = (field: string): boolean =>
  field === FEEDBACK_COLUMN_ID || field === FEEDBACK_NOTES_COLUMN_ID;
